// @ts-strict-ignore
import apisauce from 'apisauce'
import { Configuration, PharmaciesApiFactory, PlacesApiFactory } from '@dialogue/coredata'
import { select, call } from 'typed-redux-saga'

import Config from 'APP/Config'
import { selectAccessToken } from 'APP/Redux/LoginRedux'
import { AxiosInstance } from 'axios'

export function getClientConfig(accessToken: string) {
  if (!accessToken) {
    throw new Error('Missing access token')
  }

  if (!Config.EMERGENCY_ROOM_DOMAIN) {
    throw new Error('Emergency Room domain is not set')
  }

  return new Configuration({
    accessToken,
    basePath: Config.EMERGENCY_ROOM_DOMAIN as string,
  })
}

export function getAxiosClient(accessToken: string) {
  if (!accessToken) {
    throw new Error('Missing access token')
  }

  if (!Config.EMERGENCY_ROOM_DOMAIN) {
    throw new Error('Emergency Room domain is not set')
  }

  const apiClient = apisauce.create({
    baseURL: Config.EMERGENCY_ROOM_DOMAIN as string,
    headers: {
      'Cache-Control': 'no-cache',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
  })

  return apiClient.axiosInstance as AxiosInstance
}

export function* getPharmaciesApi() {
  const accessToken = yield* select(selectAccessToken)
  const axiosInstance = yield* call(getAxiosClient, accessToken)
  return PharmaciesApiFactory(getClientConfig(accessToken), '', axiosInstance)
}

export function* getPlacesApi() {
  const accessToken = yield* select(selectAccessToken)
  const axiosInstance = yield* call(getAxiosClient, accessToken)
  return PlacesApiFactory(getClientConfig(accessToken), '', axiosInstance)
}

export function createPlacesApi() {
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  const accessToken = require('APP/Store').default.getState().login.accessToken
  return PlacesApiFactory(getClientConfig(accessToken), '', getAxiosClient(accessToken))
}
